import { useEffect } from 'react';

import { useFeatureFlags } from 'src/context';
import history from 'src/history';
import { GetStartedWithOtherPortalPage } from 'src/legacy/components/Onboarding/GetStartedWithOtherPortalPage';
import { StudioSelectEmail } from 'src/routes/onboarding/setup/components/studio/StudioSelectEmail';
import { isStudioReferrer } from 'src/routes/onboarding/setup/constants';
import { useOnboardingQueryParams } from 'src/routes/onboarding/setup/hooks/useOnboardingQueryParams';
import { consumeStudioPostLoginResume } from 'src/routes/onboarding/setup/utils/studioPostLoginResume';

/**
 * /workspaces entry: Studio intent (flag or Studio referrer) gets the Studio
 * email picker; everything else keeps classic create-workspace onboarding.
 * After Cognito re-auth, a stored Studio resume path continues into setup
 * only when this page has an explicit Studio referrer (Studio login usually
 * consumes it first so existing portals do not swallow next=/workspaces).
 * Flag-only /workspaces must not honor an abandoned same-tab resume.
 */
export const WorkspacesPage = () => {
  const { EnableStudioOnboarding } = useFeatureFlags();
  const { referrer } = useOnboardingQueryParams();
  const isStudioWorkspaces =
    EnableStudioOnboarding || isStudioReferrer(referrer);
  const hasStudioReferrer = isStudioReferrer(referrer);

  useEffect(() => {
    if (!hasStudioReferrer) {
      return;
    }
    const resumePath = consumeStudioPostLoginResume();
    if (resumePath) {
      history.replace(resumePath);
    }
  }, [hasStudioReferrer]);

  if (isStudioWorkspaces) {
    return <StudioSelectEmail />;
  }

  return <GetStartedWithOtherPortalPage />;
};
